var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-crumb flex align-items-center"},[_c('span',[_vm._v("当前位置：")]),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_vm._l((_vm.breadArray),function(item,index){return [(item.path)?_c('el-breadcrumb-item',{key:'path-' + index,attrs:{"to":{
          path: item.path,
          query: Object.assign({ breadpath: 'breadpath' }, item.query),
        }}},[_vm._v(_vm._s(item.name))]):_c('el-breadcrumb-item',{key:'no-path-' + index},[_vm._v(_vm._s(item.name))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }